import type { ReactNode } from "react";

import { Navigate } from "react-router-dom";

import useLaunchModule from "~/pwa/useLaunchModule";

interface StandaloneLaunchGateProps {
	children: ReactNode;
}

const StandaloneLaunchGate = ({ children }: StandaloneLaunchGateProps) => {
	const { isPending, module } = useLaunchModule();

	if (isPending) return null;
	if (module) return <Navigate replace={true} to={module.startUrl} />;
	return <>{children}</>;
};

export default StandaloneLaunchGate;
